import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { ModalModule } from 'ngx-bootstrap';
import { BaseService } from '../../../services/base.service';
import { Http, Response } from '@angular/http';
import { INascarViewModel } from '../../../models/INascarViewModel';
import { IOrgRoleUser } from '../../../models/IOrgRoleUser';

import { ISeason } from '../../../models/ISeason';
import { IWeek } from '../../../models/IWeek';

import { IDriver } from '../../../models/IDriver'
import { IEntity } from '../../../models/IEntity';
import { NascarService } from '../../../services/nascar.service';
import { AdminService } from '../../../services/admin.service';
import { Observable } from 'rxjs/Observable';

import { AlertService } from '../../../services/alert.service';
import { IRole } from '../../../models/IRole';
import { IOrg } from '../../../models/IOrg';
import { IOrgRole } from '../../../models/IOrgRole';

import { IOrgUserRaceFilter } from '../../../models/IOrgUserRaceFilter'

@Component({
  selector: 'app-manageuserdrivers',
  templateUrl: './manageuserdrivers.component.html',
  styleUrls: ['./manageuserdrivers.component.scss']
})
export class ManageUserDriversComponent implements OnInit {

  public isRequesting: boolean = false;
  public nascarRace: INascarViewModel;
  public nascarUsers: IOrgRoleUser[];
  public roles: IRole[];
  public orgs: IOrg[];
  public orgRole: IOrgRole = { orgId: '', roleId: '' };
  public currentRole: IRole;
  public currentOrg: IOrg;
  public currentUser: IOrgRoleUser;
  public group1Drivers: IDriver[];
  public group2Drivers: IDriver[];
  public group3Drivers: IDriver[];
  public seasons: ISeason[];
  public weeks: IWeek[];
  
  public disabled: boolean = false;
  public localTime: string;
  public serverStartDateTime: Date;
  public error: any;
  public orgUserRaceFilter: IOrgUserRaceFilter = {};

  filterDriverGroup1(driver: IDriver) {
    return !(driver.group > 1)
  }

  private _alertService: AlertService;
  constructor(private adminService: AdminService,
              private nascarService: NascarService,
              private alertService: AlertService,
              private baseService: BaseService    
              ) {
    this._alertService = alertService;
  }

  ngOnInit() {
    // this.getUserList();
    ;
    this.adminService.getOrgs().subscribe(
      result => {
      this.orgs = result as IOrg[];
        this.currentOrg = this.orgs[0];
        this.orgUserRaceFilter.orgId = this.currentOrg.id;


      });

    
    this.adminService.getRoles().subscribe(
      result => {
      this.roles = result as IRole[];
        if(!this.currentRole)
          this.currentRole = this.roles[0];
      });
    this.getSeasons();
   }
   

  setCurrentOrg(org) {
    this.currentOrg = org;
    this.orgUserRaceFilter.orgId = this.currentOrg.id;
    this.getUserList();
  }
  status: { isOpen: boolean } = { isOpen: false };

  setCurrentRole($event: MouseEvent, role) {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isOpen = !this.status.isOpen;    
    this.currentRole = role;
    this.getUserList();
  }

  change(value: boolean): void {
    this.status.isOpen = value;
  }


  isDropup: boolean = true;

  autoClose: boolean = false;

  getUserRace(currentUser) {
    this.currentUser = currentUser;
    this.getCurrentOrgUserRace();
  }
  getUserList() {
    this.orgRole.orgId = this.currentOrg.id;
    this.orgRole.roleId = this.currentRole.id;
    this.adminService.getUsersByOrgRole(this.orgRole)
      .subscribe(result => {
        this.nascarUsers = result as IOrgRoleUser[];
        if (!this.currentUser)
          this.currentUser = this.nascarUsers[0];
        this.orgUserRaceFilter.userId = this.currentUser.id;
        console.log(this.nascarUsers);

      });
  }
  getCurrentOrgUserRace() {
    // this.nascarRace = this.nascarUsers.find(f => f.id == userId) as INascarViewModel;
    this.orgUserRaceFilter.orgId = this.currentOrg.id;
    this.orgUserRaceFilter.userId = this.currentUser.id;
    this.adminService.getRace(this.orgUserRaceFilter).subscribe(
      result => {
        this.nascarRace = result as INascarViewModel;
        this.nascarRace.drivers.forEach(driver => {
          driver.isSelected = false;
        })
        this.nascarRace.drivers.sort((a, b) => a.startPosition - b.startPosition);
        this.updateLocalDriverGroups();
        this.setSelectedDrivers();
        this.localTime = this.baseService.getLocalTimeFromUtc(this.nascarRace.startDateTime);    
      });



  }

  setSelectedDrivers() {
    // this.nascarRace.drivers.forEach(driver => {
    //   driver.isSelected = false;
    // })
    this.nascarRace.selectedDrivers.forEach(driver => {
      this.nascarRace.drivers.find(f => f.driverId == driver.driverId).isSelected = true;
    })
  };
  updateLocalDriverGroups() {
    this.group1Drivers = this.nascarRace.drivers.filter(f => f.group == 1);
    this.group2Drivers = this.nascarRace.drivers.filter(f => f.group == 2);
    this.group3Drivers = this.nascarRace.drivers.filter(f => f.group == 3);

  }

  assignRandomDrivers() {
    var driver1 = this.group1Drivers[Math.floor(Math.random()*this.group1Drivers.length)];
    //var driver1 = this.group1Drivers.indexOf[random];
    this.changeSelectedDriver(driver1);

    var driver2 = this.group2Drivers[Math.floor(Math.random()*this.group2Drivers.length)];
    this.changeSelectedDriver(driver2);

    var driver3 = this.group3Drivers[Math.floor(Math.random()*this.group3Drivers.length)];
    this.changeSelectedDriver(driver3);
  }


  changeSelectedDriver(driver) {
    this.nascarRace.drivers.filter(f => f.group == driver.group)
      .forEach(a => a.isSelected = false);
    this.nascarRace.drivers.filter(f => f.driverId == driver.driverId)
      .forEach(b => b.isSelected = true);

    this.updateLocalDriverGroups();

    this.nascarService.updateCurrentOrgUserRace(this.nascarRace).subscribe(data => {
      if (data)
        this._alertService.success("Driver Updated");

    },
      error => {
        this.error = error.json() as any;
        this._alertService.error(this.error);
      }
    );
  }

  getSeasons() {
    this.nascarService.getSeasons()
      .subscribe(result => {
        this.seasons = result as ISeason[];
        this.seasons.sort((a, b) => b.name- a.name);
        this.orgUserRaceFilter.season = this.seasons[0].name;
        this.getWeeks();
      });
  }

  getWeeks() {

    this.nascarService.getWeeks(this.orgUserRaceFilter)
      .subscribe(result => {
        this.weeks = result as IWeek[];
        this.weeks.sort((a, b) => b.name - a.name);
        this.orgUserRaceFilter.weekNumber = this.weeks[0].name;
      });
  }

  setCurrentSeason($event: MouseEvent, season) {
  
    this.orgUserRaceFilter.season = season.name;
    this.getCurrentOrgUserRace();
  }

  setCurrentWeek($event: MouseEvent, week) {
    this.orgUserRaceFilter.weekNumber = week.name;
    this.getCurrentOrgUserRace();
  }
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/nascar/manageuserdrivers/manageuserdrivers.component.ts